import React from "react";
import logo from "../../assets/logo.png"; // <-- apna logo path

export default function Navbar({ onMenuClick }) {
  return (
    <div className="bg-white shadow-md px-6 py-4 flex justify-between items-center border-b">

      {/* LEFT SIDE: Hamburger + Logo */}
      <div className="flex items-center gap-4">        
        <button onClick={onMenuClick} className="text-2xl text-gray-700">
          ☰
        </button>

        {/* Label beside logo */}
        {/* <span className="font-semibold text-gray-700 text-lg">
          Powered by Synoweb
        </span> */}
      </div>

      {/* CENTER TEXT (optional) */}
      <span className="font-semibold text-gray-700 hidden md:block">
        Welcome, Admin
      </span>
      {/* Logo */}
        <img 
          src={logo} 
          alt="Synoweb Logo" 
          className="h-10 w-auto"
        />

      {/* RIGHT SIDE: Logout */}
      {/* <button
        onClick={() => {
          localStorage.removeItem("token");
          window.location.href = "/";
        }}
        className="text-red-600 font-semibold"
      >
        Logout
      </button> */}

    </div>
  );
}
